import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'chartsModelImplementation',
    label: 'Model Implementation',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
